export default {
  ru: {
    START_SEARCH: 'Ищем трансферы у нашего партнера Mozio',
    START_SEARCH_SUBTITLE: [
      'Мы не нашли трансферы от Кивитакси по вашему маршруту.',
      'Сейчас ищем доступные варианты у нашего партнера Mozio',
    ],
    START_SEARCH_SUBTITLE_NEW: 'Идет поиск',
    ROUTE_NO_RESULT: [
      'Mozio не нашел маршрут с таким местом отправления / назначения.',
      'Выберите нужный город, аэропорт, вокзал или отель из выпадающих подсказок.',
    ],
    ROUTE_NO_TRANSFERS: [
      'Mozio не предоставляет трансферы по маршруту, который вы выбрали.',
      'Чтобы найти трансфер по другому маршруту, введите новый запрос.',
    ],
    ROUTE_AND_MOZIO_NO_TRANSFERS: [
      'Mozio не предоставляет трансферы по маршруту, который вы выбрали.',
      'Возможно, вы неверно ввели адрес или название отеля. Попробуйте еще раз.',
    ],
    FREE_CANCEL: 'Бесплатная отмена заказа',
    TAXES: 'Налоги и сборы включены',
    BOOK_RIDE: 'Забронировать поездку',
    OR_SIMILAR: '(или похожие)',
    FREE_WAITING: 'Минут бесплатного ожидания: %time%',
    MOZIO_TRANSFER_TITLE: 'Трансферы от нашего партнера Mozio',
    MOZIO_NO_RESULT: 'Нет подходящих автомобилей.',
    MOZIO_NO_CAPACITY: [
      'Нет подходящих автомобилей.',
      'Закажите несколько трансферов.',
    ],
    SEARCH_TITLE: 'Поискать трансферы у нашего партнера Mozio?',
    SEARCH_SUBTITLE_FROM: 'Мы не нашли трансферы от Кивитакси по вашему маршруту. Но можем поискать варианты у нашего партнера Mozio. <br /> Для этого ниже укажите точное место отправления и нажмите «Найти».',
    SEARCH_SUBTITLE_TO: 'Мы не нашли трансферы от Кивитакси по вашему маршруту. Но можем поискать варианты у нашего партнера Mozio. <br /> Для этого ниже укажите точное место назначения и нажмите «Найти».',
    SEARCH_SUBTITLE: 'Мы не нашли трансферы от Кивитакси по вашему маршруту. Но можем поискать варианты у нашего партнера Mozio. <br /> Для этого ниже укажите точное место отправления и назначения, а затем нажмите «Найти».',
    SEARCH_SUBTITLE_FROM_NO_SALES_OR_CAPACITY: 'Для этого ниже укажите точное место отправления и нажмите «Найти».',
    SEARCH_SUBTITLE_TO_NO_SALES_OR_CAPACITY: 'Для этого ниже укажите точное место назначения и нажмите «Найти».',
    SEARCH_SUBTITLE_NO_SALES_OR_CAPACITY: 'Для этого ниже укажите точное место отправления и назначения, а затем нажмите «Найти».',
    INPUT_LABEL_FROM: 'Место отправления: адрес или название отеля',
    INPUT_LABEL_TO: 'Место назначения: адрес или название отеля',
    INPUT_PLACEHOLDER_FROM: 'Laguna Hotel',
    INPUT_PLACEHOLDER_TO: 'Radisson Hotel',
    MOZIO_SEARCH_BUTTON: 'Найти',
  },
  en: {
    START_SEARCH: 'We are checking for transfers from our partner Mozio',
    START_SEARCH_SUBTITLE: [
      'We did not find Kiwitaxi transfers on your route.',
      'Now we are looking for available options from our partner Mozio',
    ],
    START_SEARCH_SUBTITLE_NEW: 'Searching',
    ROUTE_NO_RESULT: [
      'Mozio did not find any matches for your request.',
      'Select the desired city, airport, station or hotel from the drop-down menu.',
    ],
    ROUTE_NO_TRANSFERS: [
      'Mozio does not provide transfers on the route you have chosen.',
      'Change your request to find a transfer on a different route.',
    ],
    ROUTE_AND_MOZIO_NO_TRANSFERS: [
      'Mozio does not provide transfers on the route you have chosen.',
      'You may have entered the incorrect address or hotel name. Try again.',
    ],
    FREE_CANCEL: 'Free Cancellation',
    TAXES: 'Taxes & Fees Included',
    BOOK_RIDE: 'Book ride',
    OR_SIMILAR: '(or similar)',
    FREE_WAITING: '%time% min. Free Waiting Time',
    MOZIO_TRANSFER_TITLE: 'Transfers from our partner Mozio',
    MOZIO_NO_RESULT: 'No suitable cars found.',
    MOZIO_NO_CAPACITY: [
      'No suitable cars found.',
      'Book several transfers.',
    ],
    SEARCH_TITLE: 'Do you want us to check transfers with our partner Mozio?',
    SEARCH_SUBTITLE_FROM: 'We did not find Kiwitaxi transfers matching your route. But we can check options with our partner Mozio. <br /> To do this, enter the exact place of departure and click "Search".',
    SEARCH_SUBTITLE_TO: 'We did not find Kiwitaxi transfers matching your route. But we can check options with our partner Mozio. <br /> To do this, enter the exact destination and click "Search".',
    SEARCH_SUBTITLE: 'We did not find Kiwitaxi transfers matching your route. But we can check options with our partner Mozio. <br /> To do this, enter the exact places of departure and destination and click "Search".',
    SEARCH_SUBTITLE_FROM_NO_SALES_OR_CAPACITY: 'If yes, enter the exact place of departure below and click "Search".',
    SEARCH_SUBTITLE_TO_NO_SALES_OR_CAPACITY: 'If yes, enter the exact destination below and click "Search".',
    SEARCH_SUBTITLE_NO_SALES_OR_CAPACITY: 'If yes, enter the exact places of departure and destination below and click "Search".',
    INPUT_LABEL_FROM: 'Departure: hotel name or address',
    INPUT_LABEL_TO: 'Destination: address or hotel name',
    INPUT_PLACEHOLDER_FROM: 'Laguna Hotel',
    INPUT_PLACEHOLDER_TO: 'Radisson Hotel',
    MOZIO_SEARCH_BUTTON: 'Search',
  },
  de: {
    START_SEARCH: 'Wir suchen Transfers bei unserem Partner Mozio',
    START_SEARCH_SUBTITLE: [
      'Wir haben keine Kiwitaxi-Transfers auf Ihrer Route gefunden.',
      'Jetzt suchen wir nach verfügbaren Optionen von unserem Partner Mozio',
    ],
    START_SEARCH_SUBTITLE_NEW: 'Lädt',
    ROUTE_NO_RESULT: [
      'Mozio hat keine Orte gefunden, die Ihrer Suchanfrage entsprechen.',
      'Wählen Sie im Dropdown-Menü die gewünschte Stadt, den Flughafen, Bahnhof oder das Hotel aus.',
    ],
    ROUTE_NO_TRANSFERS: [
      'Mozio bietet keine Transfers auf der von Ihnen gewählten Route an.',
      'Ändern Sie Ihre Anfrage, um einen Transfer auf einer anderen Route zu finden.',
    ],
    ROUTE_AND_MOZIO_NO_TRANSFERS: [
      'Mozio bietet keine Transfers auf der von Ihnen gewählten Route an.',
      'Möglicherweise haben Sie die Adresse oder den Hotelnamen falsch eingegeben. Versuchen Sie es nochmal.',
    ],
    FREE_CANCEL: 'Kostenfreie Stornierung',
    TAXES: 'Steuern und Gebühren sind inbegriffen',
    BOOK_RIDE: 'Fahrt buchen',
    OR_SIMILAR: '(oder ähnlich)',
    FREE_WAITING: '%time% Minuten Wartezeit kostenlos',
    MOZIO_TRANSFER_TITLE: 'Transfers von unserem Partner Mozio',
    MOZIO_NO_RESULT: 'Keine passenden Autos.',
    MOZIO_NO_CAPACITY: [
      'Keine passenden Autos.',
      'Bestellen Sie mehrere Transfers.',
    ],
    SEARCH_TITLE: 'Möchten Sie, dass wir nach Transfers bei unserem Partner Mozio schauen?',
    SEARCH_SUBTITLE_FROM: 'Wir konnten keine Kiwitaxi-Transfers finden, die Ihrer Route entsprechen. Wir können jedoch nach Optionen von unserem Partner Mozio suchen. <br /> Geben Sie dafür den genauen Abfahrtsort an und klicken Sie auf "Suchen".',
    SEARCH_SUBTITLE_TO: 'Wir konnten keine Kiwitaxi-Transfers finden, die Ihrer Route entsprechen. Wir können jedoch nach Optionen von unserem Partner Mozio suchen. <br /> Geben Sie dafür den genauen Zielort an und klicken Sie auf "Suchen".',
    SEARCH_SUBTITLE: 'Wir konnten keine Kiwitaxi-Transfers finden, die Ihrer Route entsprechen. Wir können jedoch nach Optionen von unserem Partner Mozio suchen. <br /> Geben Sie dafür die genauen Abfahrts- und Zielort an und klicken Sie auf "Suchen".',
    SEARCH_SUBTITLE_FROM_NO_SALES_OR_CAPACITY: 'Um das zu tun, geben Sie den genauen Abfahrtsort an und klicken Sie auf "Suchen".',
    SEARCH_SUBTITLE_TO_NO_SALES_OR_CAPACITY: 'Um das zu tun, geben Sie den genauen Zielort an und klicken Sie auf "Suchen".',
    SEARCH_SUBTITLE_NO_SALES_OR_CAPACITY: 'Um das zu tun, geben Sie die genauen Abfahrts- und Zielort an und klicken Sie auf "Suchen".',
    INPUT_LABEL_FROM: 'Abfahrt: Adresse oder Name des Hotels',
    INPUT_LABEL_TO: 'Ankunftsort: Adresse oder Name des Hotels',
    INPUT_PLACEHOLDER_FROM: 'Laguna Hôtel',
    INPUT_PLACEHOLDER_TO: 'Radisson Hotel',
    MOZIO_SEARCH_BUTTON: 'Suchen',
  },
  fr: {
    START_SEARCH: 'Nous recherchons des transferts de notre partenaire Mozio',
    START_SEARCH_SUBTITLE: [
      'Nous n\'avons pas trouvé de transfert de Kiwitaxi qui correspond à votre itinéraire.',
      'Nous recherchons maintenant les options disponibles chez notre partenaire Mozio.',
    ],
    START_SEARCH_SUBTITLE_NEW: 'Recherche en cours',
    ROUTE_NO_RESULT: [
      'Mozio n\'a pas trouvé d\'itinéraire avec un tel lieu de départ / destination.',
      'Essayez de trouver un endroit approprié parmi la liste déroulante.',
    ],
    ROUTE_NO_TRANSFERS: [
      'Mozio ne fournit pas de transfert sur l\'itinéraire que vous avez choisi.',
      'Pour trouver un transfert sur un itinéraire différent, entrez une nouvelle demande.',
    ],
    ROUTE_AND_MOZIO_NO_TRANSFERS: [
      'Mozio ne fournit pas de transfert sur l\'itinéraire que vous avez choisi.',
      'Vous avez peut-être mal saisi l\'adresse ou le nom de l\'hôtel. Essayez encore une fois.',
    ],
    FREE_CANCEL: 'Annulation gratuite',
    TAXES: 'Taxes et frais inclus',
    BOOK_RIDE: 'Réserver un trajet',
    OR_SIMILAR: '(ou quelque chose de similaire)',
    FREE_WAITING: '%time% min. Attente gratuite',
    MOZIO_TRANSFER_TITLE: 'Transferts de notre partenaire Mozio',
    MOZIO_NO_RESULT: 'Aucune voiture correspondante.',
    MOZIO_NO_CAPACITY: [
      'Aucune voiture correspondante.',
      'Réservez plusieurs transferts.',
    ],
    SEARCH_TITLE: 'Rechercher les transferts de notre partenaire Mozio?',
    SEARCH_SUBTITLE_FROM: 'Nous n\'avons pas trouvé de transfert de Kiwitaxi qui correspond à votre itinéraire. Mais nous pouvons rechercher des transferts de notre partenaire Mozio. <br /> Pour ce faire, spécifiez le lieu de départ exact et cliquez sur "Rechercher.',
    SEARCH_SUBTITLE_TO: 'Nous n\'avons pas trouvé de transfert de Kiwitaxi qui correspond à votre itinéraire. Mais nous pouvons rechercher des transferts de notre partenaire Mozio. <br /> Pour ce faire, spécifiez le lieu de destination exact et cliquez sur "Rechercher".',
    SEARCH_SUBTITLE: 'Nous n\'avons pas trouvé de transfert de Kiwitaxi qui correspond à votre itinéraire. Mais nous pouvons rechercher des transferts de notre partenaire Mozio. <br /> Pour ce faire, spécifiez le lieu de départ et destination exact et cliquez sur "Rechercher"',
    SEARCH_SUBTITLE_FROM_NO_SALES_OR_CAPACITY: 'Pour ce faire, spécifiez le lieu de départ exact et cliquez sur "Rechercher"',
    SEARCH_SUBTITLE_TO_NO_SALES_OR_CAPACITY: 'Pour ce faire, spécifiez le lieu de départ et destination exact et cliquez sur "Rechercher"',
    SEARCH_SUBTITLE_NO_SALES_OR_CAPACITY: 'Pour ce faire, spécifiez le lieu de départ et destination exact et cliquez sur "Rechercher"',
    INPUT_LABEL_FROM: 'Lieu de départ : adresse ou nom de l\'hôtel',
    INPUT_LABEL_TO: 'Destination : adresse ou nom de l\'hôtel',
    INPUT_PLACEHOLDER_FROM: 'Laguna Hotel',
    INPUT_PLACEHOLDER_TO: 'Radisson Hôtel',
    MOZIO_SEARCH_BUTTON: 'Rechercher',
  },
  es: {
    START_SEARCH: 'Buscamos traslados que provee nuestro socio Mozio',
    START_SEARCH_SUBTITLE: [
      'No hemos encontrado traslados para la ruta solicitada provistos por Kiwitaxi',
      'Ahora estamos buscando opciones disponibles por parte de nuestro socio Mozio',
    ],
    START_SEARCH_SUBTITLE_NEW: 'Búsqueda en progreso',
    ROUTE_NO_RESULT: [
      'Mozio no ha encontrado ruta con el lugar de partida/destino indicado.',
      'Intente encontrar el punto necesario entre las sugerencias.',
    ],
    ROUTE_NO_TRANSFERS: [
      'Mozio no efectúa traslados por la ruta solicitada.',
      'Para buscar traslado por otra ruta, inicie una nueva búsqueda.',
    ],
    ROUTE_AND_MOZIO_NO_TRANSFERS: [
      'Mozio no efectúa traslados por la ruta solicitada.',
      'Es probable que la dirección o el nombre del hotel se hayan introducido incorrectamente. Vuelva a introducirlos.',
    ],
    FREE_CANCEL: 'Cancelación gratuita',
    TAXES: 'Impuestos y gastos de gestión incluidos',
    BOOK_RIDE: 'Reservar traslado',
    OR_SIMILAR: '(o similar)',
    FREE_WAITING: 'Espera sin cargo: %time%',
    MOZIO_TRANSFER_TITLE: 'Traslados desde nuestro socio Mozio',
    MOZIO_NO_RESULT: 'No hay coches a juego.',
    MOZIO_NO_CAPACITY: [
      'No hay coches a juego.',
      'Reservar transferencias múltiples.',
    ],
    SEARCH_TITLE: '¿Desea que nosotros busquemos traslados que ofrece nuestro socio Mozio?',
    SEARCH_SUBTITLE_FROM: 'No hemos encontrado traslados de Kiwitaxi que coincidan con su ruta. Sin embargo, podemos buscar opciones que ofrece nuestro socio Mozio. <br /> Para hacerlo, indique el lugar exacto de salida, luego pulse "Buscar".',
    SEARCH_SUBTITLE_TO: 'No hemos encontrado traslados de Kiwitaxi que coincidan con su ruta. Sin embargo, podemos buscar opciones que ofrece nuestro socio Mozio. <br /> Para hacerlo, indique el lugar exacto de destino, luego pulse "Buscar".',
    SEARCH_SUBTITLE: 'No hemos encontrado traslados de Kiwitaxi que coincidan con su ruta. Sin embargo, podemos buscar opciones que ofrece nuestro socio Mozio. <br /> Para hacerlo, indique el lugar exacto de salida y destino, luego pulse "Buscar".',
    SEARCH_SUBTITLE_FROM_NO_SALES_OR_CAPACITY: 'Para hacerlo, indique el lugar exacto de salida, luego pulse "Buscar".',
    SEARCH_SUBTITLE_TO_NO_SALES_OR_CAPACITY: 'Para hacerlo, indique el lugar exacto de destino, luego pulse "Buscar".',
    SEARCH_SUBTITLE_NO_SALES_OR_CAPACITY: 'Para hacerlo, indique el lugar exacto de salida y destino, luego pulse "Buscar".',
    INPUT_LABEL_FROM: 'Lugar de salida: nombre del hotel o la dirección',
    INPUT_LABEL_TO: 'Lugar de destino: dirección o nombre del hotel',
    INPUT_PLACEHOLDER_FROM: 'Hotel Laguna',
    INPUT_PLACEHOLDER_TO: 'Hotel Radisson',
    MOZIO_SEARCH_BUTTON: 'Buscar',
  },
  pl: {
    START_SEARCH: 'Trwa wyszukiwanie transferów u naszego partnera Mozio',
    START_SEARCH_SUBTITLE: [
      'Na Twojej trasie nie znaleźliśmy transferów, wykonywanych przez Kiwitaxi.',
      'Aktualnie trwa wyszukiwanie dostępnych wariantów u naszego partnera Mozio',
    ],
    START_SEARCH_SUBTITLE_NEW: 'Trwa wyszukiwanie',
    ROUTE_NO_RESULT: [
      'Mozio nie znalazł trasy z takim miejscem początkowym / docelowym.',
      'Spróbuj znaleźć potrzebny punkt wśród rozwijanych rad.',
    ],
    ROUTE_NO_TRANSFERS: [
      'Mozio nie wykonuje transferów na wybranej przez Ciebie trasie.',
      'Aby znaleźć transfer na innej trasie, wprowadź nowe zamówienie.',
    ],
    ROUTE_AND_MOZIO_NO_TRANSFERS: [
      'Mozio nie wykonuje transferów na wybranej przez Ciebie trasie.',
      'Być może wpisany adres lub nazwa hotelu są nieprawidłowe. Spróbuj jeszcze raz.',
    ],
    FREE_CANCEL: 'Darmowe odwołanie rezerwacji',
    TAXES: 'Podatki i opłatki wliczone',
    BOOK_RIDE: 'Zarezerwuj przejazd',
    OR_SIMILAR: '(lub podobny)',
    FREE_WAITING: 'Minuty wolnego oczekiwania: %time%',
    MOZIO_TRANSFER_TITLE: 'Transfery od naszego partnera Mozio',
    MOZIO_NO_RESULT: 'Brak pasujących samochodów.',
    MOZIO_NO_CAPACITY: [
      'Brak pasujących samochodów.',
      'Zarezerwuj wiele przelewów.',
    ],
    SEARCH_TITLE: 'Poszukać transferów u naszego partnera Mozio?',
    SEARCH_SUBTITLE_FROM: 'Na wybranej trasie nie znaleźliśmy transferów Kiwitaxi. Jednak możemy poszukać wariantów u naszego partnera Mozio. <br /> W tym celu wpisz dokładne miejsce odjazdu i kliknij „Szukaj”.',
    SEARCH_SUBTITLE_TO: 'Na wybranej trasie nie znaleźliśmy transferów Kiwitaxi. Jednak możemy poszukać wariantów u naszego partnera Mozio. <br /> W tym celu wpisz dokładne miejsce docelowe i kliknij „Szukaj”.',
    SEARCH_SUBTITLE: 'Na wybranej trasie nie znaleźliśmy transferów Kiwitaxi. Jednak możemy poszukać wariantów u naszego partnera Mozio. <br /> W tym celu wpisz dokładne miejsce odjazdu oraz miejsce docelowe i kliknij „Szukaj”.',
    SEARCH_SUBTITLE_FROM_NO_SALES_OR_CAPACITY: 'W tym celu wpisz dokładne miejsce odjazdu i kliknij „Szukaj”.',
    SEARCH_SUBTITLE_TO_NO_SALES_OR_CAPACITY: 'W tym celu wpisz dokładne miejsce docelowe i kliknij „Szukaj”.',
    SEARCH_SUBTITLE_NO_SALES_OR_CAPACITY: 'W tym celu wpisz dokładne miejsce odjazdu oraz miejsce docelowe i kliknij „Szukaj”.',
    INPUT_LABEL_FROM: 'Miejsce wyjazdu: adres lub nazwa hotelu',
    INPUT_LABEL_TO: 'Punkt docelowy: adres lub nazwa hotelu',
    INPUT_PLACEHOLDER_FROM: 'Laguna Hotel',
    INPUT_PLACEHOLDER_TO: 'Radisson Hotel',
    MOZIO_SEARCH_BUTTON: 'Szukaj',
  },
  pt: {
    START_SEARCH: 'Estamos à procura de transfers do nosso parceiro Mozio',
    START_SEARCH_SUBTITLE: [
      'Nós não encontramos transfers da Kiwitáxi no roteiro escolhido.',
      'Agora estamos à procura de opções disponíveis do nosso parceiro Mozio',
    ],
    START_SEARCH_SUBTITLE_NEW: 'Pesquisa em andamento',
    ROUTE_NO_RESULT: [
      'O Mozio não encontrou um roteiro com esse local de partida / destino.',
      'Por favor, escolha a localização desejada no menu pendente.',
    ],
    ROUTE_NO_TRANSFERS: [
      'Mozio não fornece transfers no roteiro escolhido.',
      'Altere a sua pesquisa de modo a encontrar transporte numa rota diferente.',
    ],
    ROUTE_AND_MOZIO_NO_TRANSFERS: [
      'Mozio não fornece transfers no roteiro escolhido.',
      'Você pode ter digitado o endereço ou o nome do hotel incorretamente. Tente novamente.',
    ],
    FREE_CANCEL: 'Cancelamento Gratuito',
    TAXES: 'Impostos e Taxas Incluídos',
    BOOK_RIDE: '',
    OR_SIMILAR: '(ou semelhante)',
    FREE_WAITING: '%time% min. Tempo de espera',
    MOZIO_TRANSFER_TITLE: 'Transferências do nosso parceiro Mozio',
    MOZIO_NO_RESULT: 'Não há carros correspondentes.',
    MOZIO_NO_CAPACITY: [
      'Não há carros correspondentes.',
      'Reserve várias transferências.',
    ],
    SEARCH_TITLE: 'Gostaria de procurar por transfers do nosso parceiro Mozio?',
    SEARCH_SUBTITLE_FROM: 'Não encontramos transfers de Kiwitáxi no seu trajeto. Mas podemos procurar opções do nosso parceiro Mozio. <br /> Para fazer isso, especifique o local exato da partida e clique em "Procurar".',
    SEARCH_SUBTITLE_TO: 'Não encontramos transfers de Kiwitáxi no seu trajeto. Mas podemos procurar opções do nosso parceiro Mozio. <br /> Para fazer isso, especifique o destino exato e clique em "Procurar".',
    SEARCH_SUBTITLE: 'Não encontramos transfers de Kiwitáxi no seu trajeto. Mas podemos procurar opções do nosso parceiro Mozio. <br /> Para fazer isso, especifique o local exato de partida e destino e clique em "Procurar".',
    SEARCH_SUBTITLE_FROM_NO_SALES_OR_CAPACITY: 'Para fazer isso, especifique o local exato da partida e clique em "Procurar".',
    SEARCH_SUBTITLE_TO_NO_SALES_OR_CAPACITY: 'Para fazer isso, especifique o destino exato e clique em "Procurar".',
    SEARCH_SUBTITLE_NO_SALES_OR_CAPACITY: 'Para fazer isso, especifique o local exato de partida e destino e clique em "Procurar".',
    INPUT_LABEL_FROM: 'Partida: nome do hotel ou morada',
    INPUT_LABEL_TO: 'Destino: morada ou nome do hotel',
    INPUT_PLACEHOLDER_FROM: 'Hotel Laguna',
    INPUT_PLACEHOLDER_TO: 'Hotel Radisson',
    MOZIO_SEARCH_BUTTON: 'Procurar',
  },
  nl: {
    START_SEARCH: 'We zijn transfers bij onze partner Mozio voor u aan het zoeken.',
    START_SEARCH_SUBTITLE: [
      'We hebben geen transfers bij Kiwitaxi gevonden langs uw route.',
      'Nu zijn we op zoek naar de beschikbare opties bij onze partner Mozio.',
    ],
    START_SEARCH_SUBTITLE_NEW: 'Bezig met zoeken',
    ROUTE_NO_RESULT: [
      'Mozio heeft geen transfer gevonden met zo\'n vertrekpunt/ bestemming.',
      'Kies een stad, luchthaven, treinstation of een hotel uit de vervolgkeuzelijst.',
    ],
    ROUTE_NO_TRANSFERS: [
      'Mozio biedt geen transfers aan langs deze route. ',
      'Dien een nieuw verzoek in om een transfer langs een andere route te vinden.',
    ],
    ROUTE_AND_MOZIO_NO_TRANSFERS: [
      'Mozio biedt geen transfers aan langs deze route.',
      'Misschien hebt u het adres of de hotelnaam verkeerd ingevoerd. Probeer het opnieuw.',
    ],
    FREE_CANCEL: '',
    TAXES: '',
    BOOK_RIDE: '',
    OR_SIMILAR: '',
    FREE_WAITING: '',
    MOZIO_TRANSFER_TITLE: 'Overstap van onze partner Mozio',
    MOZIO_NO_RESULT: 'Geen bijpassende auto\'s.',
    MOZIO_NO_CAPACITY: [
      'Geen bijpassende auto\'s.',
      'Boek meerdere transfers.',
    ],
    SEARCH_TITLE: 'Wilt u dat we transfers zoeken bij onze partner Mozio?',
    SEARCH_SUBTITLE_FROM: 'We hebben geen Kiwitaxitransfers gevonden die overeenkomen met uw route. Maar we kunnen opties bekijken bij onze partner Mozio. <br /> Voer hiertoe de exacte vertrekplaats in en klik op "Zoeken".',
    SEARCH_SUBTITLE_TO: 'We hebben geen Kiwitaxitransfers gevonden die overeenkomen met uw route. Maar we kunnen opties bekijken bij onze partner Mozio. <br /> Voer hiertoe de exacte bestemming in en klik op "Zoeken".',
    SEARCH_SUBTITLE: 'We hebben geen Kiwitaxitransfers gevonden die overeenkomen met uw route. Maar we kunnen opties bekijken bij onze partner Mozio. <br /> Voer hiertoe de exacte vertrekplaats en de bestemming in en klik op "Zoeken".',
    SEARCH_SUBTITLE_FROM_NO_SALES_OR_CAPACITY: 'Voer hiertoe de exacte vertrekplaats in en klik op "Zoeken".',
    SEARCH_SUBTITLE_TO_NO_SALES_OR_CAPACITY: 'Voer hiertoe de exacte bestemming in en klik op "Zoeken".',
    SEARCH_SUBTITLE_NO_SALES_OR_CAPACITY: 'Voer hiertoe de exacte vertrekplaats en de bestemming in en klik op "Zoeken".',
    INPUT_LABEL_FROM: 'Vertrekplaats: adres of naam van het hotel',
    INPUT_LABEL_TO: 'Bestemming: adres of naam van het hotel',
    INPUT_PLACEHOLDER_FROM: 'Laguna Hotel',
    INPUT_PLACEHOLDER_TO: 'Radisson Hotel',
    MOZIO_SEARCH_BUTTON: 'Zoeken',
  },
  it: {
    START_SEARCH: 'Cerchiamo i transfer dal nostro partner Mozio',
    START_SEARCH_SUBTITLE: [
      'Non abbiamo trovato i transfer da KiwiTaxi al percorso desiderato.',
      'Ora cerchiamo le opzioni disponibili dal nostro partner Mozio',
    ],
    START_SEARCH_SUBTITLE_NEW: 'Ricerca in corso',
    ROUTE_NO_RESULT: [
      'Mozio non ha trovato un percorso con un luogo di partenza desiderato/ destinazione.',
      'Selezionate la città, l\'aeroporto, la stazione o l\'hotel desiderato dai suggerimenti nell’elenco a discesa.',
    ],
    ROUTE_NO_TRANSFERS: [
      'Mozio non fornisce transfer sul percorso scelto. ',
      'Per trovare il transfer su un percorso diverso, inserite la nuova richiesta.',
    ],
    ROUTE_AND_MOZIO_NO_TRANSFERS: [
      'Mozio non fornisce transfer sul percorso scelto.',
      'Probabilmente, avete inserito l’indirizzo oppure il nome dell’albergo in modo errato. Provate di nuovo.',
    ],
    FREE_CANCEL: '',
    TAXES: '',
    BOOK_RIDE: '',
    OR_SIMILAR: '',
    FREE_WAITING: '',
    MOZIO_TRANSFER_TITLE: 'Trasferimenti dal nostro partner Mozio',
    MOZIO_NO_RESULT: 'Nessuna auto corrispondente.',
    MOZIO_NO_CAPACITY: [
      'Nessuna auto corrispondente.',
      'Prenota più trasferimenti.',
    ],
    SEARCH_TITLE: 'Cercare il transfer dal nostro partner Mozio?',
    SEARCH_SUBTITLE_FROM: 'Non abbiamo trovato i transfer da Kiwitaxi sul tuo percorso. Ma possiamo cercare le opzioni dal nostro partner Mozio. <br /> Per fare questo, si deve specificare il luogo esatto della partenza e cliccare su "Cerca".',
    SEARCH_SUBTITLE_TO: 'Non abbiamo trovato i transfer da Kiwitaxi sul tuo percorso. Ma possiamo cercare le opzioni dal nostro partner Mozio. <br /> Per fare questo, si deve specificare il luogo esatto della destinazione e cliccare su "Cerca".',
    SEARCH_SUBTITLE: 'Non abbiamo trovato i transfer da Kiwitaxi sul tuo percorso. Ma possiamo cercare le opzioni dal nostro partner Mozio. <br /> Per fare questo, si deve specificare il luogo esatto della partenza e della destinazione, cliccare su "Cerca".',
    SEARCH_SUBTITLE_FROM_NO_SALES_OR_CAPACITY: 'Per fare questo, si deve specificare il luogo esatto della  partenza e cliccare su "Cerca".',
    SEARCH_SUBTITLE_TO_NO_SALES_OR_CAPACITY: 'Per fare questo, si deve specificare il luogo esatto della destinazione e cliccare su "Cerca".',
    SEARCH_SUBTITLE_NO_SALES_OR_CAPACITY: 'Per fare questo, si deve specificare il luogo esatto della partenza e della destinazione, cliccare su "Cerca".',
    INPUT_LABEL_FROM: 'Partenza: l\'indirizzo o il nome dell\'albergo',
    INPUT_LABEL_TO: 'Destinazione: indirizzo o nome dell\'albergo',
    INPUT_PLACEHOLDER_FROM: 'Laguna Hotel',
    INPUT_PLACEHOLDER_TO: 'Radisson Hotel',
    MOZIO_SEARCH_BUTTON: 'Cerca',
  },
  hu: {
    START_SEARCH: 'Transzfer keresése partnerünknél, a Mozionál',
    START_SEARCH_SUBTITLE: [
      'Mozio Nem találtunk transzfert a Kiwitaxinál az Ön által megadott útvonalra.',
      'Elérhető variációkat keresése partnerünknél, a Mozionál',
    ],
    START_SEARCH_SUBTITLE_NEW: 'Keresés folyamatban',
    ROUTE_NO_RESULT: [
      'A Mozio nem talált útvonalat a megadott indulási hellyel.',
      'Válassza ki a szükséges várost, repülőteret, pályaudvart vagy hotelt a legördülő menüből!',
    ],
    ROUTE_NO_TRANSFERS: [
      'Nincsen transzfer járatunk az Ön által megadott útvonalon.',
      'Más útvonalon közlekedő transzfer kereséséhez indítson új keresést!',
    ],
    ROUTE_AND_MOZIO_NO_TRANSFERS: [
      'Nincsen transzfer járatunk az Ön által megadott útvonalon.',
      'Valószínűleg hibásan adta meg a címet vagy a hotel nevét. Próbálja meg újra.',
    ],
    FREE_CANCEL: '',
    TAXES: '',
    BOOK_RIDE: '',
    OR_SIMILAR: '',
    FREE_WAITING: '',
    MOZIO_TRANSFER_TITLE: 'Átigazolások a partnerünktől Mozio',
    MOZIO_NO_RESULT: 'Nincsenek megfelelő autók.',
    MOZIO_NO_CAPACITY: [
      'Nincsenek megfelelő autók.',
      'Foglaljon több átutalást.',
    ],
    SEARCH_TITLE: 'Kíván transzfert keresni partnerünknél, a Mozionál?',
    SEARCH_SUBTITLE_FROM: 'Nem találtunk transzfert a Kiwitaxinál az Ön által megadott útvonalra.  Azonban kereshet tanszfert partnerünknél, a Mozionál. <br /> Ehhez csak meg kell adnia lentebb az indulás pontos helyét, utána pedig kattintson a  keresés gombra.',
    SEARCH_SUBTITLE_TO: 'Nem találtunk transzfert a Kiwitaxinál az Ön által megadott útvonalra. Azonban kereshet tanszfert partnerünknél, a Mozionál. <br /> Ehhez csak meg kell adnia lentebb a célállomás pontos helyét, utána pedig kattintson a  keresés gombra.',
    SEARCH_SUBTITLE: 'Nem találtunk transzfert a Kiwitaxinál az Ön által megadott útvonalra. Azonban kereshet tanszfert partnerünknél, a Mozionál. <br /> Ehhez csak meg kell adnia lentebb az indulás és a célállomás pontos helyét, utána pedig kattintson a  keresés gombra.',
    SEARCH_SUBTITLE_FROM_NO_SALES_OR_CAPACITY: 'Ehhez csak meg kell adnia lentebb az indulás pontos helyét, utána pedig kattintson a  keresés gombra.',
    SEARCH_SUBTITLE_TO_NO_SALES_OR_CAPACITY: 'Ehhez csak meg kell adnia lentebb a célállomás pontos helyét, utána pedig kattintson a  keresés gombra.',
    SEARCH_SUBTITLE_NO_SALES_OR_CAPACITY: 'Ehhez csak meg kell adnia lentebb az indulás és a célállomás pontos helyét, utána pedig kattintson a  keresés gombra.',
    INPUT_LABEL_FROM: 'Indulás helye: cím és a hotel neve',
    INPUT_LABEL_TO: 'Úticél: a hotel címe vagy neve',
    INPUT_PLACEHOLDER_FROM: 'Laguna Hotel',
    INPUT_PLACEHOLDER_TO: 'Radisson Hotel',
    MOZIO_SEARCH_BUTTON: 'Keresés',
  },
  ua: {
    START_SEARCH: 'Шукаємо трансфери у нашого партнера Mozio.',
    START_SEARCH_SUBTITLE: [
      'Ми не знайшли трансфери від Ківітаксі за вашим маршрутом.',
      'Зараз шукаємо доступні варіанти у нашого партнера Mozio.',
    ],
    START_SEARCH_SUBTITLE_NEW: 'Йде пошук',
    ROUTE_NO_RESULT: [
      'Mozio не знайшов маршрут з таким місцем відправлення / призначення.',
      'Виберіть потрібне місто, аеропорт, вокзал або готель з випадаючих підказок.',
    ],
    ROUTE_NO_TRANSFERS: [
      'Mozio не надає трансфери по маршруту, який ви обрали.',
      'Щоб знайти трансфер по іншому маршруту, введіть новий запит.',
    ],
    ROUTE_AND_MOZIO_NO_TRANSFERS: [
      'Mozio не надає трансфери по маршруту, який ви обрали.',
      'Можливо, ви невірно ввели адресу або назву готелю. Спробуйте ще раз.',
    ],
    FREE_CANCEL: '',
    TAXES: '',
    BOOK_RIDE: '',
    OR_SIMILAR: '',
    FREE_WAITING: '',
    MOZIO_TRANSFER_TITLE: 'Трансфери від нашого партнера Mozio',
    MOZIO_NO_RESULT: 'Немає відповідних автомобілів.',
    MOZIO_NO_CAPACITY: [
      'Немає відповідних автомобілів.',
      'Замовте кілька трансферів.',
    ],
    SEARCH_TITLE: 'Пошукати трансфери у нашого партнера Mozio?',
    SEARCH_SUBTITLE_FROM: 'Ми не знайшли трансфери від Ківітаксі за Вашим маршрутом. Але можемо пошукати варіанти у нашого партнера Mozio. <br /> Для цього нижче вкажіть точне місце відправлення і натисніть «Знайти».',
    SEARCH_SUBTITLE_TO: 'Ми не знайшли трансфери від Ківітаксі за Вашим маршрутом. Але можемо пошукати варіанти у нашого партнера Mozio. <br /> Для цього нижче вкажіть точне місце призначення і натисніть «Знайти».',
    SEARCH_SUBTITLE: 'Ми не знайшли трансфери від Ківітаксі за Вашим маршрутом. Але можемо пошукати варіанти у нашого партнера Mozio. <br /> Для цього нижче вкажіть точне місце відправлення і призначення та натисніть «Знайти».',
    SEARCH_SUBTITLE_FROM_NO_SALES_OR_CAPACITY: 'Для цього нижче вкажіть точне місце відправлення і натисніть «Знайти».',
    SEARCH_SUBTITLE_TO_NO_SALES_OR_CAPACITY: 'Для цього нижче вкажіть точне місце призначення і натисніть «Знайти».',
    SEARCH_SUBTITLE_NO_SALES_OR_CAPACITY: 'Для цього нижче вкажіть точне місце відправлення і призначення та натисніть «Знайти».',
    INPUT_LABEL_FROM: 'Місце відправлення: адреса або назва готелю',
    INPUT_LABEL_TO: 'Місце призначення: адреса або назва готелю',
    INPUT_PLACEHOLDER_FROM: 'Laguna Hotel',
    INPUT_PLACEHOLDER_TO: 'Radisson Hotel',
    MOZIO_SEARCH_BUTTON: 'Знайти',
  },
};
